const Custom = 'fc11eb63-cbf2-4d47-b44c-a9cc4d230ec9'
const Notes = '2daa5040-e86a-48df-8243-4e95a8d017cd'
const SingleSelect = '502c4eba-ad14-44cd-b32b-5996c71b4d6e'
const InherentRisk = 'a837d16d-3b1c-11ea-acd1-024ef06a0f02'
const ResidualRisk = '01696d8d-3b1d-11ea-acd1-024ef06a0f02'
const RiskControls = '58427ad5-3b1e-11ea-acd1-024ef06a0f02'
const AlertRightNow = '44c3c1f0-6998-11eb-9803-02fb79c5563a'
const SectionBreak = 'a9a02b51-699b-11eb-9803-02fb79c5563a'

export { Custom, Notes, SingleSelect, InherentRisk, ResidualRisk, RiskControls, AlertRightNow, SectionBreak }